import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {MOCK_CB_CS_HOMEPAGE, USE_MOCK_CB_CS_HOMEPAGE} from './mockdata'

export interface CsEngagedUser {
  mid: number
  avatar: string
  name: string
  level_icon_url: string
  online: boolean
  unread_count: number
  send_status: number
  level_desc?: string
  note?: string
}

export interface CbCsHomepageData {
  err_msg: string
  total_unread_count: number
  current_user: CsEngagedUser
  list: CsEngagedUser[]
}

export interface VipCsState {
  csHomepage: {
    loading: boolean
    error: string | null
    data: CbCsHomepageData | null
    current_mid: number | null
  }
  send: {
    loading: boolean
    error: string | null
    sending_mid: number | null
  }
}

function normalizeCsHomepage(data: CbCsHomepageData): CbCsHomepageData {
  return {
    ...data,
    list: data?.list ?? [],
  }
}

export const getCbCsHomepage = createAsyncThunk(
  'VipCs/getCbCsHomepage',
  async (params: {current_mid: number}, store: any) => {
    if (USE_MOCK_CB_CS_HOMEPAGE) {
      return normalizeCsHomepage(MOCK_CB_CS_HOMEPAGE)
    }
    const resp = await http.post<HiyaRes<CbCsHomepageData>>(
      '/live/hiya_socialize/cb_cs_homepage',
      params,
      {store, xcErrorToast: true}
    )
    return normalizeCsHomepage(resp.data.data)
  }
)

export const cbSend = createAsyncThunk(
  'VipCs/cbSend',
  async (params: {target_mid: number}, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/live/hiya_socialize/cb_send',
      params,
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

const initialState: VipCsState = {
  csHomepage: {
    loading: false,
    error: null,
    data: null,
    current_mid: null,
  },
  send: {
    loading: false,
    error: null,
    sending_mid: null,
  },
}

export const VipCsSlice = createSlice({
  name: 'VipCs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCbCsHomepage.pending, (state, action) => {
        Object.assign(state.csHomepage, {
          loading: true,
          error: null,
          current_mid:
            action.meta.arg?.current_mid ?? state.csHomepage.current_mid,
        })
      })
      .addCase(getCbCsHomepage.fulfilled, (state, action) => {
        Object.assign(state.csHomepage, {
          loading: false,
          error: null,
          data: action.payload,
        })
      })
      .addCase(getCbCsHomepage.rejected, (state, action) => {
        Object.assign(state.csHomepage, {
          loading: false,
          error: action.error?.message || '获取失败',
        })
      })
      .addCase(cbSend.pending, (state, action) => {
        Object.assign(state.send, {
          loading: true,
          error: null,
          sending_mid: action.meta.arg?.target_mid ?? null,
        })
      })
      .addCase(cbSend.fulfilled, (state) => {
        Object.assign(state.send, {
          loading: false,
          error: null,
          sending_mid: null,
        })
      })
      .addCase(cbSend.rejected, (state, action) => {
        Object.assign(state.send, {
          loading: false,
          error: action.error?.message || '发送失败',
          sending_mid: null,
        })
      })
  },
})

export default VipCsSlice.reducer

export const useVipCsState = () => useSelector((state) => state.VipCs)
